import { engineComponent } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { ContainerElement } from "../../Components/Elements/Graphics/ContainerElement";
import { PickController } from "./PickController";
import { Spot } from "./Spot";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../../Utils/FrameTimer";
import { GameManager } from "../../Managers/GameManager";
import { PlayList } from "../../Components/Sounds/PlayList";
import { Symbol } from "../Symbol";
import { WinAnimator2 } from "../../CustomComponents/WinAnimator2";
import { Tweens } from "../../Components/Effects/Tweens";
import { BaseView } from "../Base/BaseView";
import { HtmlController } from "../../HTMLComponents/HtmlController";
import { ModuleManager } from "../../Managers/ModuleManager";

@engineComponent(ComponentTypes.DisplayObject)
export class PickView extends ContainerElement {
    public static ActualValue: number = 0;
    public static ActualValueType: string = "";

    private _controller: PickController;

    private _reelLights: Array<SwitchElement> = [];
    private _spots: Array<Spot> = [];
    private _bottomContainer: ContainerElement;
    private _topContainer: ContainerElement;
    private _transition: SwitchElement;

    private _statusTimer: FrameTimerEventEmitter;
    private _status: string;

    private _actualReel: number = -1;
    private _actualValue: number = -1;
    private _actualValueType: string = "";
    private _pickSelected: number = 0;

    private _fsMessageStart: HTMLElement;

    private _outroDelay: FrameTimerEventEmitter;

    constructor() {
        super();

        this._statusTimer = CreateFrameTimer("statusTimer");
        this._statusTimer.on(FrameTimerEvents.Complete, this.statusTimerComplete.bind(this));

        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));
    }

    create(node: Element): void {
        super.create(node);

        if (this.childs != null) {
            if (this.childs["BottomContainer"] != null) {
                this._bottomContainer = this.childs["BottomContainer"];
            }
            if (this.childs["TopContainer"] != null) {
                this._topContainer = this.childs["TopContainer"];
            }

            let i: number;

            for (i = 0; i < 15; i++) {
                if (this.childs["Spot_" + i] != null) {
                    this._spots.push(this.childs["Spot_" + i]);
                }
            }

            for (i = 0; i < 5; i++) {
                if (this.childs["ReelLight_" + i] != null) {
                    this._reelLights.push(this.childs["ReelLight_" + i]);
                }
            }

            if (this.childs["Transition"] != null) {
                this._transition = this.childs["Transition"];
            }
        }

        this._fsMessageStart = document.getElementById("fsMessageStart");
        if (this._fsMessageStart == null) {
            if (DEBUG) {
                this.log("ERROR no fsMessageStart");
            }
        }

        this.resetChildren();
    }

    private resetChildren() {
        let i: number;
        if (this._spots != null) {
            this._topContainer.alpha = 1;
            this._bottomContainer.alpha = 1;
            for (i = 0; i < this._spots.length; i++) {
                if (this._bottomContainer != null) {
                    this._bottomContainer.addChild(this._spots[i]);
                }
                this._spots[i].goToCase("HIDE");
                this._spots[i].visible = true;
                this._spots[i].alpha = 1;
                this._spots[i].enabled = false;
            }
        }

        if (this._reelLights != null) {
            for (i = 0; i < this._reelLights.length; i++) {
                this._reelLights[i].goToCase("HIDE");
                this._reelLights[i].alpha = 1;
            }
        }
    }

    private statusTimerComplete(): void {
        switch (this._status) {
            case "start":
                this.enabledSpots();
                this.introFinished();
                break;
            case "selectUpdate":
                this.updateCountersValues();
                break;
            case "select":
                this.enabledSpots();
                this._controller.selectComplete();
                break;
            case "updateCounters":
                this.updateCounters();
                break;
            case "showWin":
                this.showWin();
                break;
        }
    }

    disableLogo(): void {
        if (this.childs["Logo"] != null) {
            this.removeChild(this.childs["Logo"]);
        }
    }

    initReceived(controller: PickController): void {
        if (DEBUG) {
            this.log("initReceived");
        }

        this._controller = controller;
    }

    initIntro(): void {
        this._pickSelected = 0;
        this.resetChildren();
        if (
            GameManager.pickResponse != null &&
            GameManager.pickResponse.round != null &&
            GameManager.pickResponse.round.spots != null
        ) {
            if (ModuleManager.freespinsEnabled()) {
                PlayList.loop("SND_FSloop");
            } else {
                PlayList.loop("SND_FSpickupMusic");
            }

            if (BaseView.Background != null) {
                BaseView.Background.goToCase("PICK_START");
            }

            this.visible = true;

            let i: number = 0;
            for (let key in GameManager.pickResponse.round.spots) {
                let id: number = GameManager.pickResponse.round.spots[key].id;
                let status: string = GameManager.pickResponse.round.spots[key].status.toString();
                let addDelay: boolean = true;
                let value: number = null;
                let valueType: string = null;
                if (GameManager.pickResponse.round.spots[key].value != null) {
                    value = parseInt(GameManager.pickResponse.round.spots[key].value + "");
                }

                if (GameManager.pickResponse.round.spots[key].valueType != null) {
                    valueType = GameManager.pickResponse.round.spots[key].valueType.toString();
                }

                if (id != null && status != null) {
                    if (this._spots != null && this._spots[id] != null) {
                        let symbol: Symbol = this.getSymbolFromBaseGame(id);
                        switch (status) {
                            case "enabled":
                                if (symbol != null) {
                                    addDelay = false;
                                    symbol.visible = false;
                                    this._spots[id].goToCase("START_NOW");
                                }

                                this._spots[id].enabled = true;
                                break;
                            case "disabled":
                                if (symbol != null) {
                                    addDelay = false;
                                    symbol.visible = false;
                                    this._spots[id].goToCase("START_NOW");
                                }
                                break;
                            case "revealed":
                                this._pickSelected++;
                                if (symbol != null) {
                                    addDelay = false;
                                    symbol.visible = false;
                                    this._spots[id].enabled = false;
                                    if (value != null && valueType != null) {
                                        this._actualValue = value;
                                        PickView.ActualValue = value;
                                        this._actualValueType = valueType;
                                        PickView.ActualValueType = valueType;

                                        if (this._topContainer != null) {
                                            this._topContainer.addChild(this._spots[id]);
                                        }
                                        let reel: number;
                                        switch (id) {
                                            case 0:
                                                reel = 0;
                                                break;
                                            case 1:
                                                reel = 0;
                                                break;
                                            case 2:
                                                reel = 0;
                                                break;
                                            case 3:
                                                reel = 1;
                                                break;
                                            case 4:
                                                reel = 1;
                                                break;
                                            case 5:
                                                reel = 1;
                                                break;
                                            case 6:
                                                reel = 2;
                                                break;
                                            case 7:
                                                reel = 2;
                                                break;
                                            case 8:
                                                reel = 2;
                                                break;
                                            case 9:
                                                reel = 3;
                                                break;
                                            case 10:
                                                reel = 3;
                                                break;
                                            case 11:
                                                reel = 3;
                                                break;
                                            case 12:
                                                reel = 4;
                                                break;
                                            case 13:
                                                reel = 4;
                                                break;
                                            case 14:
                                                reel = 4;
                                                break;
                                        }

                                        if (valueType === "count") {
                                            if (this._reelLights != null && reel != null) {
                                                if (this._reelLights[reel] != null) {
                                                    this._reelLights[reel].goToCase("RED");
                                                }
                                            }
                                            this._spots[id].goToCase("REVEALED_FS_" + value + "_WIN");
                                        } else if (valueType === "multiplier") {
                                            if (this._reelLights != null && reel != null) {
                                                if (this._reelLights[reel] != null) {
                                                    this._reelLights[reel].goToCase("BLUE");
                                                }
                                            }
                                            this._spots[id].goToCase("REVEALED_MLP_" + value + "_WIN");
                                        }
                                    }
                                }
                                break;
                            case "shown":
                                if (symbol != null) {
                                    addDelay = false;
                                    symbol.visible = false;
                                    this._spots[id].enabled = false;
                                    if (value != null && valueType != null) {
                                        this._spots[id].goToCase("DISABLED");
                                        if (valueType === "count") {
                                            this._spots[id].goToCase("SHOWN_FS_" + value + "_WIN");
                                        } else if (valueType === "multiplier") {
                                            this._spots[id].goToCase("SHOWN_MLP_" + value + "_WIN");
                                        }
                                    }
                                }
                                break;
                        }
                    }
                }
                if (addDelay) {
                    i++;
                }
            }

            this._status = "select";
            this._statusTimer.start(1);
        }
    }

    collect(): void {}

    start(): void {}

    select(): void {}

    end(): void {}

    startReceived(): void {}

    selectReceived(): void {
        if (
            GameManager.pickResponse != null &&
            GameManager.pickResponse.round != null &&
            GameManager.pickResponse.round.spots != null
        ) {
            let i: number = 0;
            for (let key in GameManager.pickResponse.round.spots) {
                let id: number = GameManager.pickResponse.round.spots[key].id;
                let status: string = GameManager.pickResponse.round.spots[key].status.toString();

                let value: number = null;
                let valueType: string = null;

                if (GameManager.pickResponse.round.spots[key].value != null) {
                    value = parseInt(GameManager.pickResponse.round.spots[key].value + "");
                }

                if (GameManager.pickResponse.round.spots[key].valueType != null) {
                    valueType = GameManager.pickResponse.round.spots[key].valueType.toString();
                }

                if (id != null && status != null) {
                    if (this._spots != null && this._spots[id] != null) {
                        switch (status) {
                            case "revealed":
                                this._pickSelected++;
                                if (this._spots[id].enabled) {
                                    this._spots[id].enabled = false;
                                    if (value != null && valueType != null) {
                                        this._actualValue = value;
                                        PickView.ActualValue = value;
                                        this._actualValueType = valueType;
                                        PickView.ActualValueType = valueType;

                                        if (this._topContainer != null) {
                                            this._topContainer.addChild(this._spots[id]);
                                        }

                                        PlayList.play("SND_FSpickupDraw");

                                        if (valueType === "count") {
                                            this._spots[id].goToCase("REVEALED_FS_" + value);
                                        } else if (valueType === "multiplier") {
                                            this._spots[id].goToCase("REVEALED_MLP_" + value);
                                        }
                                    }
                                }
                                break;
                            case "shown":
                                if (this._spots[id].enabled) {
                                    this._spots[id].enabled = false;
                                    if (value != null && valueType != null) {
                                        this._spots[id].goToCase("DISABLED");
                                        if (valueType === "count") {
                                            this._spots[id].delayedGoToCase(60, "SHOWN_FS_" + value);
                                        } else if (valueType === "multiplier") {
                                            this._spots[id].delayedGoToCase(60, "SHOWN_MLP_" + value);
                                        }
                                    }
                                }
                                break;
                        }
                    }
                }
                i++;
            }

            this._status = "showWin";
            this._statusTimer.start(30);
        }
    }

    showWin(): void {
        if (this._actualValueType != null) {
            if (this._actualValueType === "count") {
                PlayList.play("SND_FSPickupChipXFS");
            } else if (this._actualValueType === "multiplier") {
                PlayList.play("SND_FSPickupChipXMT");
            }
        }

        this._status = "updateCounters";
        this._statusTimer.start(30);
    }

    updateCounters(): void {
        this._controller.updateCounters();
        if (this._actualValue != -1 && this._actualValueType != "") {
            if (this._actualValueType === "count") {
                if (this._reelLights != null && this._actualReel != -1) {
                    if (this._reelLights[this._actualReel] != null) {
                        this._reelLights[this._actualReel].goToCase("RED");
                    }
                }
            } else if (this._actualValueType === "multiplier") {
                if (this._reelLights != null && this._actualReel != -1) {
                    if (this._reelLights[this._actualReel] != null) {
                        this._reelLights[this._actualReel].goToCase("BLUE");
                    }
                }
            }
        }
        this._status = "selectUpdate";
        this._statusTimer.start(60);
    }

    updateCountersValues(): void {
        this._controller.updateCountersValues();
        this._actualReel = -1;
        this._actualValue = -1;
        PickView.ActualValue = -1;
        this._actualValueType = "";
        PickView.ActualValueType = "";
        this._status = "select";
        this._statusTimer.start(20);
    }

    endReceived(): void {
        PlayList.play("SND_FSWin");
        PlayList.stop("SND_FSpickupMusic");
        PlayList.loop("SND_FSloop");

        if (this._fsMessageStart != null && this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
            this._fsMessageStart.classList.remove(HtmlController.DisabledClass);
        }
    }

    intro(long: boolean = false): void {
        this._pickSelected = 0;
        this.resetChildren();

        if (
            GameManager.pickResponse != null &&
            GameManager.pickResponse.round != null &&
            GameManager.pickResponse.round.spots != null
        ) {
            PlayList.stop("SND_FSWinLoop");
            PlayList.loop("SND_FSpickupMusic");

            if (BaseView.Background != null) {
                BaseView.Background.goToCase("PICK_START");
            }

            this.visible = true;

            let i: number = 0;
            for (let key in GameManager.pickResponse.round.spots) {
                let id: number = GameManager.pickResponse.round.spots[key].id;
                let status: string = GameManager.pickResponse.round.spots[key].status.toString();
                let addDelay: boolean = true;

                if (id != null && status != null) {
                    if (this._spots != null && this._spots[id] != null) {
                        let symbol: Symbol = this.getSymbolFromBaseGame(id);
                        switch (status) {
                            case "enabled":
                                if (symbol != null) {
                                    if (symbol.id === 9) {
                                        addDelay = false;
                                        symbol.visible = false;
                                        this._spots[id].goToCase("START_NOW");
                                    } else {
                                        Tweens.removeTweens(symbol);
                                        Tweens.alphaTween(symbol, {
                                            alphas: [1, 0],
                                            tweenDuration: 5,
                                            tweenDelay: 10 * i,
                                        });
                                        this._spots[id].delayedGoToCase(10 * i, "START");
                                    }
                                }

                                this._spots[id].enabled = true;
                                break;
                            case "disabled":
                                if (symbol != null) {
                                    if (symbol.id === 9) {
                                        addDelay = false;
                                        symbol.visible = false;
                                        this._spots[id].goToCase("START_NOW");
                                    } else {
                                        Tweens.removeTweens(symbol);
                                        Tweens.alphaTween(symbol, {
                                            alphas: [1, 0],
                                            tweenDuration: 5,
                                            tweenDelay: 10 * i,
                                        });

                                        this._spots[id].delayedGoToCase(10 * i, "START");
                                    }
                                }
                                break;
                        }
                    }
                }
                if (addDelay) {
                    i++;
                }
            }

            this._status = "start";
            this._statusTimer.start(i * 10 + 30);
        }
    }

    enabledSpots(): void {
        if (
            GameManager.pickResponse != null &&
            GameManager.pickResponse.round != null &&
            GameManager.pickResponse.round.spots != null
        ) {
            let i: number = 0;
            for (let key in GameManager.pickResponse.round.spots) {
                let id: number = GameManager.pickResponse.round.spots[key].id;
                let status: string = GameManager.pickResponse.round.spots[key].status.toString();

                if (id != null && status != null) {
                    if (this._spots != null && this._spots[id] != null) {
                        switch (status) {
                            case "enabled":
                                this._spots[id].enabled = true;
                                this._spots[id].goToCase("ENABLED");
                                if (this._reelLights != null) {
                                    switch (id) {
                                        case 2:
                                            this._actualReel = 0;
                                            if (this._reelLights[0] != null) {
                                                this._reelLights[0].goToCase("START");
                                            }
                                            break;
                                        case 5:
                                            this._actualReel = 1;
                                            if (this._reelLights[1] != null) {
                                                this._reelLights[1].goToCase("START");
                                            }
                                            break;
                                        case 8:
                                            this._actualReel = 2;
                                            if (this._reelLights[2] != null) {
                                                this._reelLights[2].goToCase("START");
                                            }
                                            break;
                                        case 11:
                                            this._actualReel = 3;
                                            if (this._reelLights[3] != null) {
                                                this._reelLights[3].goToCase("START");
                                            }
                                            break;
                                        case 14:
                                            this._actualReel = 4;
                                            if (this._reelLights[4] != null) {
                                                this._reelLights[4].goToCase("START");
                                            }
                                            break;
                                    }
                                }
                                break;
                            case "disabled":
                                this._spots[id].goToCase("DISABLED");
                                break;
                        }
                    }
                }
                i++;
            }
        }
    }

    getSymbolFromBaseGame(id: number): Symbol {
        if (WinAnimator2.Symbols != null) {
            switch (id) {
                case 0:
                    return WinAnimator2.Symbols[0][0];
                case 1:
                    return WinAnimator2.Symbols[0][1];
                case 2:
                    return WinAnimator2.Symbols[0][2];
                case 3:
                    return WinAnimator2.Symbols[1][0];
                case 4:
                    return WinAnimator2.Symbols[1][1];
                case 5:
                    return WinAnimator2.Symbols[1][2];
                case 6:
                    return WinAnimator2.Symbols[2][0];
                case 7:
                    return WinAnimator2.Symbols[2][1];
                case 8:
                    return WinAnimator2.Symbols[2][2];
                case 9:
                    return WinAnimator2.Symbols[3][0];
                case 10:
                    return WinAnimator2.Symbols[3][1];
                case 11:
                    return WinAnimator2.Symbols[3][2];
                case 12:
                    return WinAnimator2.Symbols[4][0];
                case 13:
                    return WinAnimator2.Symbols[4][1];
                case 14:
                    return WinAnimator2.Symbols[4][2];
            }
        }
        return null;
    }

    introFinished(): void {
        this._controller.introFinished();
    }

    outro(): void {
        if (this._transition != null) {
            PlayList.play("SND_FSTransition");
            this._transition.goToCase("START");
        }
        Tweens.removeTweens(this._bottomContainer);
        Tweens.alphaTween(this._bottomContainer, {
            alphas: [1, 0],
            tweenDuration: 30,
        });

        Tweens.removeTweens(this._topContainer);
        Tweens.alphaTween(this._topContainer, {
            alphas: [1, 0],
            tweenDuration: 30,
        });

        let i: number = 0;

        if (this._reelLights != null) {
            for (i = 0; i < this._reelLights.length; i++) {
                Tweens.removeTweens(this._reelLights[i]);
                Tweens.alphaTween(this._reelLights[i], {
                    alphas: [1, 0],
                    tweenDuration: 10 * i,
                });
            }
        }

        if (this._transition != null) {
            this._transition.goToCase("START");
        }

        if (WinAnimator2.Symbols != null) {
            for (i = 0; i < WinAnimator2.Symbols.length; i++) {
                for (let j: number = 0; j < WinAnimator2.Symbols[i].length; j++) {
                    if (
                        WinAnimator2.Symbols[i][j] != null &&
                        (WinAnimator2.Symbols[i][j].visible || WinAnimator2.Symbols[i][j].alpha === 1)
                    ) {
                        Tweens.removeTweens(WinAnimator2.Symbols[i][j]);
                        Tweens.alphaTween(WinAnimator2.Symbols[i][j], {
                            alphas: [1, 0],
                            tweenDuration: 30,
                        });
                    }
                }
            }
        }
        this._outroDelay.start(60);
    }

    outroFinished(): void {
        this.visible = false;
        let i: number = 0;
        if (WinAnimator2.Symbols != null) {
            for (i = 0; i < WinAnimator2.Symbols.length; i++) {
                for (let j: number = 0; j < WinAnimator2.Symbols[i].length; j++) {
                    if (
                        WinAnimator2.Symbols[i][j] != null &&
                        (WinAnimator2.Symbols[i][j].visible || WinAnimator2.Symbols[i][j].alpha === 1)
                    ) {
                        WinAnimator2.Symbols[i][j].alpha = 1;
                    }
                }
            }
        }
        this._controller.outroFinished();
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Pick/PickView.ts
 **/